import axios from 'axios';
import { API_BASE } from './apiConfig';

// Global Admin-only, not space-scoped — bare axios + API_BASE, same convention as
// configApi.js/analyticsApi.js (NOT spaceClient, see CcuSettings.jsx).
const ADMIN = `${API_BASE}/api/admin`;

export const getCcuSettingsConfig = () =>
  axios.get(`${ADMIN}/ccu-settings`).then((r) => r.data);

// One combined save — dto = { settings, extraCcuSpaceIds }. The backend treats
// extraCcuSpaceIds as the complete desired extra-share set (replace, not merge).
export const updateCcuSettings = (dto) =>
  axios.put(`${ADMIN}/ccu-settings`, dto).then((r) => r.data);
